import { Box, Link } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import * as styles from './style.css';

interface ImageCardProps {
  url: string;
  imageUrl: string;
  htag: string;
  cropImage?: boolean;
  children: ReactNode;
}
const ImageCard = ({
  url,
  imageUrl,
  htag,
  cropImage = true,
  children,
}: ImageCardProps) => (
  <Box className={styles.container}>
    <Link href={url} className={styles.linkContainer} data-htag={htag}>
      {cropImage && (
        <div
          className={styles.backgroundImage}
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: cropImage ? 'cover' : 'contain',
            height: '180px',
          }}
        />
      )}
      {!cropImage && <img className={styles.backgroundImage} src={imageUrl} />}
      <Box background="surface" padding="medium" className={styles.imageCard}>
        {children}
      </Box>
    </Link>
  </Box>
);
export default ImageCard;
